import { Controller } from "@hotwired/stimulus"
import { showNotification } from "./helpers"

// Zastepuje widget Intuma, ktory nie dziala z Turbo — patrz doc/llm/tailwind_stimulus.md, „Formularze Intuma” (#35418)
export default class extends Controller {
  static targets = ["container", "instruction"]
  static values = { url: String, prefill: Object, errorMessage: String }

  connect() {
    this.load()
  }

  async load() {
    if (this.loading || this.loaded) return // connect() moze poleciec ponownie

    this.loading = true
    try {
      await this.render()
    } finally {
      this.loading = false
    }
  }

  async render() {
    const html = await this.fetchForm()
    if (!html.trim()) return // Intum niedostepny: modal zostaje bez formularza, jak przy widgecie

    this.containerTarget.innerHTML = html

    const form = this.containerTarget.querySelector("form")
    if (!form) return

    this.loadedAt = Date.now()
    this.applyPrefill(form)
    this.activateScripts()

    // Odpowiedz z form.action to JSON, nie strona — natywny submit nie moze wyjsc
    form.addEventListener("submit", event => event.preventDefault())
    form.querySelector("[data-form='submit']")?.addEventListener("click", () => this.submit(form))
    this.loaded = true // dopiero po podpieciu listenerow: snapshot Turbo klonuje HTML, ale nie nasluchy
  }

  async fetchForm() { // pusty HTML zamiast wyjatku, zeby niedostepny Intum nie wywalal konsoli
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Content-Type": "text/html; charset=utf-8" }
      })

      return response.ok ? await response.text() : ""
    } catch {
      return ""
    }
  }

  applyPrefill(form) { // klucze prefilla to atrybuty data-code pol Intuma, np. { field3616: "a@b.pl" }
    Object.entries(this.prefillValue).forEach(([code, value]) => {
      const field = form.querySelector(`[data-code="${code}"]`)
      if (field) field.value = value
    })
  }

  activateScripts() { // innerHTML nie wykonuje skryptow, a Intum wstawia je razem z formularzem
    this.containerTarget.querySelectorAll("script").forEach(original => {
      const script = document.createElement("script")
      script.textContent = original.textContent
      original.parentNode.replaceChild(script, original)
    })
  }

  // Zadna sciezka nie moze skonczyc sie cicho: klik bez reakcji to zgubione zamowienie paczki
  async submit(form) {
    this.fields(form).forEach(field => field.setCustomValidity(""))
    this.normalizeRequiredCheckboxes(form)

    // Wymagane pole e-mail jest ukryte, wiec bledu walidacji przegladarka nie ma jak pokazac
    if (!form.reportValidity()) {
      showNotification(this.errorMessageValue)
      return
    }

    const data = new FormData(form)
    data.set("_form_elapsed", Math.floor((Date.now() - this.loadedAt) / 1000).toString())
    const result = await this.postForm(form, data)

    if (result?.errors) {
      Object.entries(result.errors).forEach(([code, message]) => this.fieldFor(form, code)?.setCustomValidity(message))
      form.reportValidity()
      showNotification(Object.values(result.errors).join(" "))
    } else if (result?.render) {
      form.innerHTML = result.render
      // Potwierdzenie z Intuma zastepuje formularz, wiec "zamow konta ponizej" przestaje byc prawda
      if (this.hasInstructionTarget) this.instructionTarget.classList.add("hidden")
    } else if (result?.redirect) {
      window.location.href = result.redirect
    } else {
      showNotification(this.errorMessageValue) // brak odpowiedzi albo nieznany format = nie wiemy, czy poszlo
    }
  }

  async postForm(form, data) {
    try {
      const response = await fetch(form.action, { method: "POST", body: data, referrerPolicy: "strict-origin" })

      return response.ok ? await response.json() : null
    } catch {
      return null
    }
  }

  fields(form) {
    return [...form.querySelectorAll("[id^='result_results']")]
  }

  fieldFor(form, code) { // Intum zwraca kod pola, a formularz ma id w formacie result_results_<kod>
    return this.fields(form).find(field => field.id.endsWith(`_${code}`))
  }

  normalizeRequiredCheckboxes(form) { // grupa wymagana jako calosc: required na pierwszym, gdy nic nie zaznaczono
    form.querySelectorAll("[data-field-required=true]").forEach(group => {
      const checkboxes = [...group.querySelectorAll("input[type='checkbox']")]
      const anyChecked = checkboxes.some(checkbox => checkbox.checked)

      checkboxes.forEach((checkbox, index) => { checkbox.required = !anyChecked && index === 0 })
    })
  }
}
